import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getExtrasDetailList = createAsyncThunk(
  "extrasDetailList/getExtrasDetailList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/extra_utility/get_all_data`,

        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        data
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const extrasDetailSlice = createSlice({
  name: "extrasDetailList",
  initialState: {
    loading: false,
    extrasDetailData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getExtrasDetailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getExtrasDetailList.fulfilled, (state, action) => {
        state.loading = false;
        state.extrasDetailData = action.payload;
      })
      .addCase(getExtrasDetailList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default extrasDetailSlice.reducer;
